var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLockWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40835 4.19064C4.26304 4.20786 4.14153 4.07502 4.19333 3.93816C4.62212 2.80539 5.71701 2 7 2C8.283 2 9.37788 2.80539 9.80667 3.93817C9.85847 4.07503 9.73697 4.20786 9.59165 4.19064C9.51374 4.18141 9.43526 4.17395 9.35624 4.1683L7.71247 4.05089C7.23809 4.01701 6.76191 4.01701 6.28753 4.05089L4.64376 4.1683C4.56474 4.17395 4.48626 4.18141 4.40835 4.19064ZM1.91992 5.21656C1.97116 5.17644 2.00087 5.11472 2.00024 5.04965C2.00008 5.03312 2 5.01657 2 5C2 2.23858 4.23858 0 7 0C9.76142 0 12 2.23858 12 5C12 5.01657 11.9999 5.03312 11.9998 5.04965C11.9991 5.11472 12.0288 5.17644 12.0801 5.21656C13.2528 6.13478 14 7.56299 14 9.1556V11.8444C14 14.4676 11.9728 16.6448 9.35624 16.8317L7.71247 16.9491C7.23809 16.983 6.76191 16.983 6.28753 16.9491L4.64376 16.8317C2.02724 16.6448 0 14.4676 0 11.8444V9.1556C0 7.56299 0.747238 6.13478 1.91992 5.21656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockWhite);
export default __webpack_public_path__ + "static/media/ic_lock_white.fa1e5b9c67cdb49221640801173037ac.svg";
export { ForwardRef as ReactComponent };